module.exports = __webpack_public_path__ + "img/traffic-junction-6.a1b6fc0d.webp";